<template>
	<v-layout>
		<v-flex sm12 md6>
			<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="mb-2">
				<div class="add-event-step-header mb-0">Add-ons / Extras<span v-if="!getHost.can_add_extras">*</span></div>
				<v-tooltip top v-if="addonStarted">
					<v-btn flat class="error" slot="activator" @click="clearExtra" style="min-width: 40px; width: 40px;"><v-icon>fal fa-trash-alt</v-icon></v-btn>
					<span>Clear this Addon</span>
				</v-tooltip>
			</div>
			<p class="add-event-step-sub-header mb-1" style="color: #BBB"><i>*Optional</i></p>
			<p class="add-event-step-sub-header mb-0">Hosts are not permitted to solicit Guest to purchase goods or services at an event, but they can offer additional services to Guests if it is included before hand. Some services can be included right in the WRKPRTY experience (and therefore included in the event price), but sometimes hosts wish to offer something more on the side.</p>
			<p class="add-event-step-sub-header mt-2 error--text" v-if="!getHost.can_add_extras">*Contact us to request access to this feature.</p>
			
			<p class="add-event-step-secondary-header mb-0 mt-4">Add-On title</p>
			<v-text-field color="link" hide-details class="d-inline-block mb-4 pt-0" placeholder="Title" v-model="title" :disabled="!getHost.can_add_extras"></v-text-field>
			<p class="add-event-step-secondary-header mb-0 mt-4">Describe the Add-On or Extra you are offering</p>
			<p class="add-event-step-sub-header mb-0">Is it a pre-wrkprty yoga session? A home-cooked 3 course lunch? Remember, brevity and clariy go a long way!</p>
			<v-textarea color="link" hide-details class="d-inline-block mb-4 pt-0" placeholder="Description" v-model="description" :disabled="!getHost.can_add_extras"></v-textarea>
			<p class="add-event-step-secondary-header mb-0 mt-4">This will happen...</p>
			<p class="add-event-step-error mb-2" v-if="!scheduleSelected">
				Please select a <a @click="goToSchedule()">Date & Time</a> for your event before adding extras.
			</p>
			<v-radio-group v-model="timeSlot" class="pt-1" :disabled="!getHost.can_add_extras || !scheduleSelected">
				<v-radio v-for="t in timeSlots" :key="t.value" :label="t.text" :value="t.value" :disabled="!getHost.can_add_extras || !scheduleSelected"></v-radio>
			</v-radio-group>
	<!-- 		<v-select
				:items="timeSlots"
				v-model="timeSlot"
				label="Time slot"
				single-line
			></v-select> -->
			<div class="hidden-xs-only align-center" style="display: inline-flex; width: 100%">
				<v-select
					:disabled="!getHost.can_add_extras || !scheduleSelected || !timeSlot"
					:items="startTimesFunc"
					@change="endTime = null"
					v-model="startTime"
					label="Start Time"
					single-line
				></v-select>
				<p class="text-xs-center ml-3 mr-3 pt-1">To</p>
				<v-select
					:disabled="!getHost.can_add_extras || !scheduleSelected || !timeSlot || startTime === null"
					:items="endTimesFunc"
					v-model="endTime"
					label="End Time"
					single-line
				></v-select>
			</div>
			<div class="hidden-sm-and-up">
				<v-select
					:disabled="!getHost.can_add_extras || !scheduleSelected || !timeSlot"
					:items="startTimesFunc"
					@change="entTime = null"
					v-model="startTime"
					label="Start Time"
					single-line
				></v-select>
				<v-select
					:disabled="!getHost.can_add_extras || !scheduleSelected || !timeSlot || startTime === null"
					:items="endTimesFunc"
					v-model="endTime"
					label="End Time"
					single-line
				></v-select>
			</div>
			<p class="add-event-step-secondary-header mb-0">How much will the add-on increase the Event Ticket Price?</p>
			<p class="add-event-step-sub-header">Depending on what you are offering, this price could range significantly. A 30 minute massage? A one-hour long workout session? Lunch? Dinner? Prices vary. Think about what price will encourage signups! And remember, this cost is IN ADDITION TO the event price.</p>
			<v-text-field color="link" id="price" placeholder="5" :error="!validPrice" class="pa-5 mb-2" v-model="price" type="number" :rules="[rules.price]" prepend-icon="fal fa-dollar-sign" :disabled="!getHost.can_add_extras"></v-text-field>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card>
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-example-content"><i>Think you might have a great Add-on to offer, but not sure how to present it?</i></p>
					<p class="add-event-example-content">Check out these examples to get ideas:</p>
					<p class="text-xs-center add-event-example-sub-header-light"><v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>Example {{exampleIndex+1}}/{{examples.length}}<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn></p>
					<p class="add-event-example-sub-header-light">Description</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].description"></p>
					<p class="add-event-example-sub-header-light mt-4">Time</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].timeSlot"></p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].time"></p>
					<p class="add-event-example-sub-header-light mt-4">Fee</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].fee"></p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card class="add-event-tip-box" style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<div class="d-block text-xs-center" style="width: 100%;">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</div>
					<p style="display: block;" class="add-event-example-sub-header-light">Example {{exampleIndex+1}}/{{examples.length}}</p>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="height: 50vh;">
					<p class="add-event-example-content"><i>Think you might have a great Add-on to offer, but not sure how to present it?</i></p>
					<p class="add-event-example-content">Check out these examples to get ideas:</p>
					<p class="add-event-example-sub-header-light">Description</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].description"></p>
					<p class="add-event-example-sub-header-light mt-4">Time</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].timeSlot"></p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].time"></p>
					<p class="add-event-example-sub-header-light mt-4">Fee</p>
					<p class="add-event-example-content mb-0" v-html="examples[exampleIndex].fee"></p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
					<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { replaceNewlines, parseTimeString, mod } from '~/store/util/util'
import moment from 'moment'
export default {
	data() {
		return {
			startTimeError: false,
			endTimeError: false,
			timeSlots: [
				{ text: 'Before event', value: 'before' },
				{ text: 'During event', value: 'during' },
				{ text: 'After event', value: 'after' }
			],
			startTimes: [],
			endTimes: [],
			validPrice: false,
			rules: {
				price: value => {
					if (value >= 0 || value === null) {
						this.validPrice = true
						return true
					}
					this.validPrice = false
					return 'Price must be equal or greater than $0'
				},
			},
			exampleIndex: 0,
			examples: [
				{
					description:
						'Morning Yoga with host and certified Vinyasa instructor and practitioner for over twenty years, Malory. We’ll focus on breathwork and warming up our minds and bodies to start the morning centered energized. What to bring: if you have a mat, please bring it!',
					timeSlot: 'Before the event',
					time: '8am - 8:45',
					fee: '$10'
				},
				{
					description:
						'Home-cooked 3 Course Lunch, prepared and served by Kristof, a chef and former restaurateur. About the menu: this meal is an ode to the experience of dining at my favorite Izakaya in Japan! I usually weave a few bites into our family meals, but by popular demand, I’ve decided to put more of those courses together for a complete, and absolutely delicious, Izakaya lunch.',
					timeSlot: 'During the event',
					time: '12p - 1pm',
					fee: '$12'
				},
				{
					description:
						'Guess what? I’m an Award-Winning LA Photographer. Since I have all the gear here set up and ready to go, I’m offering up to 4 headshot sessions (15 minutes each) while the work-sprints are underway. I’ll take about 30 pics and, after the event, put the finishing touches on 2 for your professional use. (And I will happily send you the remaining pics, just won’t be able to color correct, etc. for this deal. Thanks!',
					timeSlot: 'During the event',
					time: '9am - 1pm',
					fee: '$30'
				},
				{
					description:
						'Whether from stress, physical recovery, or long days working over the computer, I am offering 20 min Massages. I am a trained, certified Massage Therapist. A rejuvenated mind is more productive!',
					timeSlot: 'During the event',
					time: '10:30am - 2pm',
					fee: '$10'
				},
				{
					description:
						'Awesome 30 minute HiiT Quickie Workout, by host and founder of ThisIsFitWorkouts. If youd like to participate please bring an exercise mat or large towel, a water bottle, and workout clothes. There are locker rooms where you can change and fitness equipment will be provided. The workouts are modifiable to all levels!',
					timeSlot: 'After the event',
					time: '4:15 - 4:45',
					fee: '$5'
				},
				{
					description:
						'Pregame: Coffee and Chat. Come before the WRKPRTY begins to ease into the flow with coffee and conversations!',
					timeSlot: 'Before the event',
					time: '8:30am - 9am',
					fee: '$0'
				}
			]
		}
	},
	mounted() {
	},
	beforeRouteLeave(to, from, next) {
		if (this.getHost.can_add_extras) {
			// this.saveAddonTemplate().then((response) => {
			// 	// if (this.getAddEventProp('addonId') !== null) {
			// 	// 	this.setAddEventValidStep(from.path)
			// 	// 	this.removeAddEventInvalidStep(from.path)
			// 	// } else {
			// 	// 	this.removeAddEventValidStep(from.path)
			// 	// 	this.setAddEventInvalidStep(from.path)
			// 	// }
			// }).catch((response) => {
			// })
			if (this.isValid) {
				this.setAddEventValidStep(from.path)
				this.removeAddEventInvalidStep(from.path)
			} else if (this.addonStarted) {
				this.removeAddEventValidStep(from.path)
				this.setAddEventInvalidStep(from.path)
			}
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddEventProp',
			'saveAddonTemplate',
			'setAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventValidStep',
			'removeAddEventInvalidStep'
		]),
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		},
		newlines(value) {
			return replaceNewlines(value)
		},
		goToSchedule() {
			this.$router.push('/host/add/event/schedule')
		},
		clearExtra() {
			this.title = null
			this.description = null
			this.price = null
			this.startTime = null
			this.endTime = null
			this.timeSlot = null
			this.removeAddEventInvalidStep(this.$route.path)
		}
	},
	watch: {
		timeSlot(value) {
			this.setTimes(value)
		}
	},
	computed: {
		...mapGetters(['getAddEventProp', 'getHost']),
		scheduleSelected() {
			if (
				this.getAddEventProp('date') &&
				this.getAddEventProp('startTime') &&
				this.getAddEventProp('endTime')
			) {
				return true
			} else {
				return false
			}
		},
		startTimesFunc() {
			let times = []
			if (this.timeSlot === 'before') {
				let tempMoment = moment(this.getAddEventProp('startTime'))
				for (var i = 0; i < 4 * 4; i++) {
					tempMoment.subtract(15, 'm')
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
				}
				times.reverse()
			} else if (this.timeSlot === 'during') {
				let tempMoment = moment(this.getAddEventProp('startTime'))
				while (tempMoment < moment(this.getAddEventProp('endTime'))) {
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
					tempMoment.add(15, 'm')
				}
			} else if (this.timeSlot === 'after') {
				let tempMoment = moment(this.getAddEventProp('endTime'))
				for (var j = 0; j < 4 * 4; j++) {
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
					tempMoment.add(15, 'm')
				}
			}

			return times
		},
		endTimesFunc() {
			let times = []
			if (this.timeSlot === 'before') {
				let tempMoment = moment(this.startTime)
				var i = 0
				while (tempMoment < moment(this.getAddEventProp('startTime'))) {
					tempMoment.add(15, 'm')
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
				}
			} else if (this.timeSlot === 'during') {
				let tempMoment = moment(this.startTime)
				while (tempMoment < moment(this.getAddEventProp('endTime'))) {
					tempMoment.add(15, 'm')
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
				}
			} else if (this.timeSlot === 'after') {
				let tempMoment = moment(this.startTime)
				for (var j = 0; j < 4 * 4; j++) {
					tempMoment.add(15, 'm')
					times.push({text: tempMoment.format('h:mma'), value: tempMoment.format()})
				}
			}

			return times
		},
		addonStarted() {
			return (
				this.title !== null ||
				this.description !== null ||
				this.timeSlot !== null ||
				this.startTime !== null ||
				this.endTime !== null ||
				this.price !== null
			)
		},
		isValid() {
			if (
				this.title !== null &&
				this.title !== '' &&
				this.description !== null &&
				this.description !== '' &&
				this.timeSlot !== null &&
				this.price !== null &&
				this.price !== '' &&
				this.validPrice &&
				!this.startTimeError &&
				!this.endTimeError
			) {
				return true
			} else {
				return false
			}
		},
		title: {
			get() {
				return this.getAddEventProp('addonTitle')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonTitle', value: val })
			}
		},
		description: {
			get() {
				return this.getAddEventProp('addonDescription')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonDescription', value: val })
			}
		},
		price: {
			get() {
				return this.getAddEventProp('addonPrice')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonPrice', value: val })
			}
		},
		timeSlot: {
			get() {
				return this.getAddEventProp('addonTimeSlot')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonTimeSlot', value: val })
			}
		},
		startTime: {
			get() {
				return this.getAddEventProp('addonStartTime')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonStartTime', value: val })
			}
		},
		endTime: {
			get() {
				return this.getAddEventProp('addonEndTime')
			},
			set(val) {
				this.setAddEventProp({ prop: 'addonEndTime', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
